//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VueHorizontal from 'vue-horizontal'

export default {
  components: { VueHorizontal },
  computed: {
    showSuperbanner() {
      const valid_bookmakers = ['netbetie', 'netbetgr', 'netbetlatam', 'netbetro', 'netbetcom'];
      if (valid_bookmakers.includes(this.$config.BOOKMAKER)) {
        return true;
      }

      if(this.$config.ENVIRONMENT == 'staging') {
        return true;
      }
      if(_.get(this.$route.query, 'superbanner') == 1) {
        return true;
      }
      return false;
    },
    tabs() {
      return _.get(this.sportTabs, this.selectedSection, [])
    },
    sportTabs() {
      return _.get(this.$store.state, 'games.homeTabs', [])
    },
    selectedSection: {
      get() {
        return this.$store.state.homeSection
      },
      set(value) {
        this.$store.commit('setHomeSection', value)
      }
    },
    currentTab() {
      return _.find(this.tabs, {slug: this.selectedTab});
    },
    selectedTab: {
      get() {
        return this.$store.state.homeTab
      },
      set(value) {
        this.$store.commit('setHomeTab', value)
      }
    },
  },
  watch: {
    sportTabs: function (val) {
      if (!this.selectedTab && this.selectedSection && _.size(this.sportTabs)) {
        this.selectedTab = _.get(_.first(_.get(this.sportTabs, this.selectedSection)), 'slug')
      }
    },
    selectedSection: function (val) {
      if (!this.selectedTab && this.selectedSection && _.size(this.sportTabs)) {
        this.selectedTab = _.get(_.first(_.get(this.sportTabs, this.selectedSection)), 'slug')
      }
    }
  },
  data() {
    return {
      sections: [
        { id: 'live', competitionId: null, label: this.$t('In-Play') },
        { id: 'highlights', competitionId: null, label: this.$t('Highlights') },
        { id: 'today', competitionId: null, label: this.$t('Today') },
        { id: 'upcoming', competitionId: null, label: this.$t('Upcoming') }
      ],
      //sportTabs: [],
      //selectedSection: null,
      //selectedTab: null,
      images: ['/images/carousel_0.png','/images/carousel_1.png','/images/carousel_2.png'],
      sports: []
    }
  },
  async mounted() {
    if (tock.active('home')) {
      tock.clear('home')
    }
    //this.selectedTab = _.first(this.tabs)
    this.getHome()
    if (!this.selectedSection) {
      this.selectSection('highlights')
    }
    if (!this.selectedTab) {
      //this.selectedTab = _.get(_.get(this.sportTabs, this.selectedSection), 'id')
    }

    tock.setInterval('home',() => {this.getHome()}, 30 * 1000)
    /*
    this.homeInterval = setInterval(() => {
      this.getHome()
    }, 10000)*/
  },
  beforeUnmount: function () {
    tock.clear('home')
  },
  methods: {
    async getHome() {
      this.$content().get('home', {
          params: {
            lang: this.lang,
            bookmaker: this.$config.BOOKMAKER,
            //cache: luxon.DateTime.now().toFormat('f'),
          }
        })
        .then((response) => {
          response = _.get(response, 'data')
          this.$store.commit('games/setHomeTabs', _.get(response, 'data.tabs'))
          //this.sportTabs = _.get(response, 'data.tabs')
          if (!this.selectedSection) {
            this.selectSection('highlights')
          }
          if (!this.selectedTab) {
            this.selectedTab = _.get(_.first(this.sportTabs), 'slug')
          }
          this.loading = false
          if (this.$refs.horizontal) this.$refs.horizontal.refresh(console.log)
        })
        .catch(function (error) {
          console.log(error) // handle error
        })
    },
    async selectSection(tab) {
      this.selectedSection = tab
      //console.log('_.get(this.sportTabs, this.selectedSection)', this.sportTabs, this.selectedSection)
      //this.selectedTab = _.get(_.get(this.sportTabs, this.selectedSection), 'id')
      this.selectedTab = _.get(_.first(_.get(this.sportTabs, this.selectedSection)), 'slug')

      try {
        this.$refs.horizontal.scrollToIndex(0)
        setTimeout(() => {
          if (this.$refs.horizontal) this.$refs.horizontal.refresh(console.log)
          this.$refs.horizontal.scrollToIndex(0)
        }, 300)
        
      } catch (e) {}
    },
    async selectTab(tab) {
      this.selectedTab = tab
    }
  }
}
